import { IUser } from 'app/containers/Authorization/slice/types';
import {
  IAccessRightsNumbers,
  IFormPermissions,
  IHiikoEnvironmentAdministrationView,
  ISimpleUser,
} from 'app/containers/User/slice/types';

/* --- STATE --- */
export interface CompanyState {
  companyList: {
    companiesArr: ICompanyInList[];
    loading: boolean;
  };
  companyForm: {
    loading: boolean;
    isOpen: boolean;
    type: CompanyFormType;
    id?: number;
  };
  shareCompanyForm: {
    deleteLoading: boolean;
    loading: boolean;
    isOpen: boolean;
    type: CompanyShareFormType;
    id?: number;
    permissions?: IFormPermissions;
  };
  companyDetails: {
    loading: boolean;
    company: ICompanyDetails | null;
  };

  selectedCompanyId: number | null;
  selectedCompanyGroupId: number | null;
}

export type CompanyShareFormType = 'share' | 'edit';

export type CompanyFormType = 'create' | 'edit';

export interface ICompanyInList {
  id: number;
  name: string;
  companyCode: string;
  city: string;
  accepted: boolean;
  owner: boolean;
}

export interface ICompanyFormValues {
  juridicalCode: string;
  juridicalStatus: juridicalStatusEnum;
  city: string;
  farmerCode?: string | null;
  vatCode: string;
  street: string;
  sprayingCode?: string | null;
  name: string;
  postalCode: string;
  houseNumber: string;
  companyCode: string;

  county: string;
  country: string;
}

export interface ICreateCompany extends ICompanyFormValues {
  hiikoEnvironmentId: number;
}
export interface IUpdateCompany extends ICreateCompany {
  id: number;
}

export interface ICompany extends ICompanyFormValues {
  id: number;
  hiikoEnvironmentId: number;
  createdOn: string;
  updatedOn: string;
  user: IUser;
}

export enum juridicalStatusEnum {
  farmersFarm = 'farmersFarm',
  agriculturalCompany = 'agriculturalCompany',
  cooperative = 'cooperative',
  limitedLiabilityCompany = 'limitedLiabilityCompany',
}

export enum companyFormEnum {
  juridicalCode = 'juridicalCode',
  juridicalStatus = 'juridicalStatus',
  city = 'city',
  farmerCode = 'farmerCode',
  vatCode = 'vatCode',
  street = 'street',
  sprayingCode = 'sprayingCode',
  name = 'name',
  postalCode = 'postalCode',
  houseNumber = 'houseNumber',
  companyCode = 'companyCode',

  county = 'county',
  country = 'country',
  // legalStatus = 'legalStatus',
}

export interface ICompanyShareFormValues extends IFormPermissions {
  id: string;
}

export enum shareCompanyFormEnum {
  id = 'id',
  taskAdministration = 'taskAdministration',
  fieldAdministration = 'fieldAdministration',
  resourceAdministration = 'resourceAdministration',
  cultureAdministration = 'cultureAdministration',
  usersAdministration = 'usersAdministration',
  companyAdministration = 'companyAdministration',
}

/* --- PAYLOADS --- */
export interface IDeleteShareCompanyPayload {
  envId: number;
  guestEnvId: number;
  companyId: number;
}

export interface ISetCompanyFormTypePayload {
  type: CompanyFormType;
  companyId?: string;
}

export interface ISetShareCompanyFormTypePayload {
  type: CompanyShareFormType;
  permissions?: IAccessRightsNumbers;
  id?: number;
}

export interface IEditCompanyPayload {
  envId: number;
  id: number;
  values: ICompanyFormValues;
}

export interface IGetCompanyByIdPayload {
  envId: number;
  companyId: number;
}

export interface IShareCompanyPayload {
  id: string;
  permissions: IFormPermissions;
  envId: number;
  companyId: number;
}

export interface IShareCompanyData extends IHiikoEnvironmentAdministrationView {
  hiikoEnvironmentId: number;
}

export enum companyListTableColEnum {
  name = 'name',
  companyCode = 'companyCode',
  city = 'city',
  accepted = 'accepted',
  owner = 'owner',
}

interface ICompanyDetailsBase {
  id: number;
  name: string;
  city: string;
  juridicalStatus: juridicalStatusEnum;
  juridicalCode: string;
  companyCode: string;
  vatCode: string;
  farmerCode: string | null;
  sprayingCode: string | null;
  country: string;
  county: string;
  street: string;
  houseNumber: string;
  postalCode: string;
  createdOn: string;
  updatedOn: string;
  user: {
    id: number;
    name: string;
    lastName: string;
    email: string;
    phoneNr: string;
    companyCount: number;
  } | null;
  ownerEnvironment: ICompanyHiikoEnvironmentsRawData;
}
export interface ICompanyHiikoEnvironmentsBase {
  hiikoEnvironment: {
    id: number;
    name: string;
    user: {
      id: number;
      name: string;
      lastName: string;
      email: string;
      phoneNr: string;
      companyCount: number;
    };
    countryCode: string;
  };
  accepted: boolean;
  role: string;
}

export interface ICompanyHiikoEnvironmentsRawData
  extends IHiikoEnvironmentAdministrationView,
    ICompanyHiikoEnvironmentsBase {}

export interface ICompanyDetailsResponse extends ICompanyDetailsBase {
  companyHiikoEnvironments: ICompanyHiikoEnvironmentsRawData[];
}

export interface ICompanyHiikoEnvironmentsData
  extends ICompanyHiikoEnvironmentsBase {
  permissions: IAccessRightsNumbers;
}

export interface ICompanyDetails extends ICompanyDetailsBase {
  companyHiikoEnvironments: ICompanyHiikoEnvironmentsData[];
}

export interface ICompanyGroup {
  companies: ICompanyInList[];
  createdAt: string;
  createdBy: ISimpleUser;
  envId: number;
  id: number;
  name: string;
  updatedAt: string;
  updatedBy: ISimpleUser;
}
